import React, { useState, useEffect } from "react";
import {
  ArrowRight,
  Play,
  Shield,
  CheckCircle,
  Building,
  Users,
  BarChart3,
  CreditCard,
  Repeat,
  Clock,
  DollarSign,
  TrendingUp,
  Zap,
  Headphones,
  Shuffle,
  ArrowDownCircle,
  ArrowUpCircle,
  FileCheck,
  Video,
  Antenna,
  FileText,
  ShieldCheck,
  Cloud,
  Lock,
  Brain,
  Rocket,
  Globe,
  Banknote,
  Smartphone,
  FolderOpen,
} from "lucide-react";
import Header from "./header";
import Footer from "./footer";
import HeroSlider from "./slider";


const BusinessLanding = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [currentText, setCurrentText] = useState(0);
  const [hasFlipped, setHasFlipped] = useState(false);
  const [currentFeature, setCurrentFeature] = useState(0);


  const texts = ["Payment Gateway", "Backed by Blockchain"];
  useEffect(() => {
    if (!hasFlipped) {
      const timer = setTimeout(() => {
        setCurrentText(1);
        setHasFlipped(true);
      }, 2000); // Flip after 2 seconds of page load

      return () => clearTimeout(timer);
    }
  }, [hasFlipped]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText(prev => prev === 0 ? 1 : 0);
    }, 3000);

    setIsVisible(true);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const smoothScrollStyles = `
    html {
      scroll-behavior: smooth;
    }
    
    @media (prefers-reduced-motion: no-preference) {
      html {
        scroll-behavior: smooth;
      }
    }
    
    /* Add all your keyframes here */
    @keyframes typewriter {
      0% {
        width: 0;
      }
      100% {
        width: 100%;
      }
    }
    
    @keyframes blink {
      0%, 50% {
        opacity: 1;
      }
      51%, 100% {
        opacity: 0;
      }
    }
    
    @keyframes wave {
      0%, 100% {
        transform: translateY(0) scale(1);
      }
      50% {
        transform: translateY(-10px) scale(1.2);
      }
    }
    
    @keyframes orbit1 {
      0% {
        transform: rotate(0deg) translateX(30px) rotate(0deg);
      }
      100% {
        transform: rotate(360deg) translateX(30px) rotate(-360deg);
      }
    }
    
    @keyframes orbit2 {
      0% {
        transform: rotate(120deg) translateX(30px) rotate(-120deg);
      }
      100% {
        transform: rotate(480deg) translateX(30px) rotate(-480deg);
      }
    }
    
    @keyframes orbit3 {
      0% {
        transform: rotate(240deg) translateX(30px) rotate(-240deg);
      }
      100% {
        transform: rotate(600deg) translateX(30px) rotate(-600deg);
      }
    }
    
    /* CSS Classes */
    .perspective-1000 {
      perspective: 1000px;
    }
    
    .transform-style-preserve-3d {
      transform-style: preserve-3d;
    }
    
    .backface-hidden {
      backface-visibility: hidden;
    }
    
    .rotate-y-0 {
      transform: rotateY(0deg);
    }
    
    .rotate-y-180 {
      transform: rotateY(180deg);
    }
    
    .typewriter-text-1 {
      animation: typewriter 1s steps(12) forwards;
      animation-delay: 0.5s;
      width: 0;
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
    }
    
    .typewriter-text-2 {
      animation: typewriter 1s steps(8) forwards;
      animation-delay: 1.5s;
      width: 0;
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
    }
    
    .typewriter-cursor {
      animation: blink 1s infinite;
      animation-delay: 2.5s;
    }
    
    .wave-animation {
      animation: wave 1.5s ease-in-out infinite;
    }
      
  `;

    const styleSheet = document.createElement('style');
    styleSheet.innerText = smoothScrollStyles;
    document.head.appendChild(styleSheet);

    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);


  // Add smooth scroll styles
  useEffect(() => {
    const smoothScrollStyles = `
      html {
        scroll-behavior: smooth;
      }
      
      @media (prefers-reduced-motion: no-preference) {
        html {
          scroll-behavior: smooth;
        }
      }
    `;


    const styleSheet = document.createElement('style');
    styleSheet.innerText = smoothScrollStyles;
    document.head.appendChild(styleSheet);


    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);


  // Smooth scroll function
  const smoothScrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };
  // Handle card click navigation
  const handleCardClick = (url) => {
    window.location.href = url;
  };
  const paymentSolutions = [
    {
      id: 1,
      icon: <CreditCard className="w-12 h-12 text-white" />,
      title: "Payin Solution",
      description: "Seamless deposit functionality with multiple payment methods",
      color: "from-blue-500 to-cyan-600",
      bgColor: "bg-gradient-to-br from-blue-50 to-cyan-50",
      url: "/PaymentSolutionsLanding",
      imagePath: "/payin1.png",
      features: [
        "Multiple payment gateways",
        "Real-time transaction processing",
        "Instant notifications",
        "Secure payment handling"
      ]
    },
    {
      id: 2,
      icon: <Banknote className="w-12 h-12 text-white" />,
      title: "Payout Solution",
      description: "Quick and secure withdrawal options for users",
      color: "from-emerald-500 to-teal-600",
      bgColor: "bg-gradient-to-br from-emerald-50 to-teal-50",
      url: "/PayoutProcessLanding",
      imagePath: "/payout.png",
      features: [
        "Instant payouts",
        "Multiple withdrawal methods",
        "Automated processing",
        "Fraud protection"
      ]
    },
    {
      id: 3,
      icon: <BarChart3 className="w-12 h-12 text-white" />,
      title: "Reconciliation",
      description: "Streamlined reconciliation of transactions and settlements",
      color: "from-green-500 to-emerald-600",
      bgColor: "bg-gradient-to-br from-green-50 to-emerald-50",
      url: "/ReconciliationPage",
      imagePath: "/Reconciliation.png",
      features: [
        "Automated transaction matching",
        "Discrepancy detection",
        "Detailed reporting",
        "Settlement validation"
      ]
    }
  ];

  const merchant = [
    {
      icon: <Cloud className="w-7 h-7" />, // Add your icon for "Scalable"
      title: "Scalable",
      desc: "Handle millions of transactions daily.",
      color: "purple"
    },
    {
      icon: <Lock className="w-7 h-7" />, // Add your icon for "Secure"
      title: "Secure",
      desc: "Bank-grade encryption & compliance (PCI-DSS).",
      color: "pink"
    },
    {
      icon: <Brain className="w-7 h-7" />, // Add your icon for "Intelligent"
      title: "Intelligent",
      desc: "AI-driven fraud detection, smart routing, reconciliation.",
      color: "orange"
    },
    {
      icon: <Rocket className="w-7 h-7" />, // Add your icon for "Faster Go-Live"
      title: "Faster Go-Live",
      desc: "From onboarding to activation in days, not weeks.",
      color: "teal"
    },
    {
      icon: <Globe className="w-7 h-7" />, // Add your icon for "Multi-Industry Ready"
      title: "Multi-Industry Ready",
      desc: "Banking & Fintech, Retail & E-commerce, Logistics",
      color: "cyan"
    }
  ];


  const features = [
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Faster Go to Market",
      desc: "Accelerated development cycles that get your products to market quickly",
      color: "blue",
    },
    {
      icon: <TrendingUp className="w-8 h-8" />,
      title: "Scalability",
      desc: "Flexible architecture designed to scale seamlessly with your growth",
      color: "purple",
    },
    {
      icon: <Building className="w-8 h-8" />,
      title: "Established Accelerators & Frameworks",
      desc: "Empower teams with proven growth strategies",
      color: "green",
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Value-driven Engagement",
      desc: "Building meaningful connections through shared value",
      color: "cyan",
    },
    {
      icon: <Zap className="w-8 h-8" />,
      title: "Lightning Fast",
      desc: "Process payments in milliseconds",
      color: "orange",
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: "Omnichannel",
      desc: "Optimized for all devices",
      color: "cyan",
    },
  ];
  // Our Products (NETC & Merchant Management)
  const ourProducts = [
    {
      id: 1,
      icon: <Shuffle className="w-16 h-16" />,
      title: "UPI Switch",
      description: "Seamless UPI transaction switching and routing for high performance and reliability",
      color: "from-green-500 to-emerald-600",
      url: "/switch",
      features: [
        "Transaction switching",
        "High availability",
        "Dynamic routing",
        "Failover support"
      ]
    },
    {
      id: 2,
      icon: <ArrowDownCircle className="w-16 h-16" />,
      title: "Payment Gatewaye Suite",
      description: "Quick and secure deposit and withdrawal options for users with multiple methods",
      color: "from-blue-500 to-cyan-600",
      url: "/paymentSolutions",
      features: [
        "UPI, Cards, Net Banking, Wallets, EMI & more",
        "Smart routing, AI-driven Fraud & Risk Management",
        "Refund & chargeback management",
        "Merchant & Reseller Panels with MIS & reporting"
      ]
    },
    // {
    //   id: 3,
    //   icon: <ArrowUpCircle className="w-16 h-16" />,
    //   title: "Pay-Out",
    //   description: "Quick and secure withdrawal options for users with multiple methods",
    //   color: "from-teal-500 to-sky-600",
    //   url: "/paymentSolutions",
    //   features: [
    //     "Bulk payouts",
    //     "Instant transfers",
    //     "Compliance support",
    //     "Comprehensive tracking"
    //   ]
    // },
    {
      id: 3,
      icon: <FileCheck className="w-16 h-16" />,
      title: "Recon With AI",
      description: "Streamlined reconciliation of transactions and settlements",
      color: "from-gray-500 to-slate-600",
      url: "/recon",
      features: [
        "Automated matching",
        "Dispute resolution",
        "Compliance reports",
        "Audit trail"
      ]
    },
    {
      id: 4,
      icon: <Users className="w-16 h-16" />,
      title: "Merchant Management",
      description: "Complete merchant lifecycle management with advanced tools and insights",
      color: "from-amber-500 to-orange-600",
      url: "/Merchant",
      features: [
        "Onboarding automation",
        "Performance analytics",
        "Risk management",
        "Support tools"
      ]
    },
    {
      id: 5,
      icon: <Shield className="w-16 h-16" />,
      title: "NETC Solutions",
      description: "Advanced acquirer management, transaction routing, issuing, processing, and analytics.",
      color: "from-purple-500 to-indigo-600",
      url: "/netc",
      features: [
        "Transaction routing",
        "Merchant management",
        "Real-time monitoring",
        "Settlement processing"
      ]
    },
    // {
    //   id: 6,
    //   icon: <Zap className="w-16 h-16" />,
    //   title: "NETC Issuer",
    //   description: "Advanced issuing and transaction processing with comprehensive analytics",
    //   color: "from-rose-500 to-pink-600",
    //   url: "/netc",
    //   features: [
    //     "Card issuance",
    //     "Transaction authorization",
    //     "Account management",
    //     "Reporting & analytics"
    //   ]
    // },

    {
      id: 6,
      icon: <Video className="w-16 h-16" />, // Use a video-related icon
      title: "Video KYC",
      description: "Secure and compliant video-based customer verification",
      color: "from-indigo-500 to-purple-600",
      url: "/HubLiveLanding",
      features: [
        "Real-time identity verification",
        "AI-based facial recognition",
        "Document validation",
        "Regulatory compliance"
      ]
    }
    ,
    {
      id: 7,
      icon: <FolderOpen className="w-16 h-16" />, // Use a folder/document-related icon
      title: "Document Management System",
      description: "Centralized platform for storing, organizing, and securing documents",
      color: "from-emerald-500 to-teal-600",
      url: "/dms",
      features: [
        "Version control",
        "Role-based access",
        "Metadata tagging",
        "Secure cloud storage"
      ]
    }

  ];




  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <Header />
      <HeroSlider />
      {/* Business Solutions - Dark */}
      {/* <div className="bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 py-20 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            Complete Business Solutions
            <br />
            for the Digital Age
          </h1>
          <p className="text-xl text-white/90 mb-8">
            Payments, Ecommerce, Analytics, CRM, and FinTech - All in one platform
          </p>
          <div className="flex justify-center">
            <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center" onClick={() => smoothScrollTo('gateway')}>
              <button
                onClick={() => smoothScrollTo('gateway')}
                className="text-blue-600 hover:text-blue-800 transition-colors focus:outline-none"
              >
                <ArrowRight className="w-6 h-6 text-blue-600" />
              </button>
            </div>
          </div>
        </div>
      </div> */}


      <div id="gateway" className="scroll-mt-20">
        {/* <section className="py-16 px-4 bg-gradient-to-br from-slate-50 via-purple-50 to-pink-100 relative overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-20 -right-20 w-40 h-40 bg-gradient-to-br from-purple-200 to-pink-300 rounded-full opacity-30"></div>
            <div className="absolute top-1/2 -left-20 w-32 h-32 bg-gradient-to-br from-blue-200 to-cyan-300 rounded-full opacity-30"></div>
            <div className="absolute -bottom-20 right-1/3 w-36 h-36 bg-gradient-to-br from-emerald-200 to-teal-300 rounded-full opacity-30"></div>
          </div>

          <div className="max-w-7xl mx-auto relative">
            <div className="flex flex-col lg:flex-row items-center gap-12 mb-16">
              <div className="lg:w-1/2 flex justify-center">
                <video
                  className="w-80 h-96 object-cover rounded-3xl shadow-2xl"
                  src="./video1.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  controls={false}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'flex';
                  }}
                />
                <div className="w-80 h-96 bg-gradient-to-br from-purple-500 to-pink-600 rounded-3xl shadow-2xl items-center justify-center text-white text-center hidden">
                  <CreditCard className="w-24 h-24 mx-auto mb-4" />
                  <p className="text-lg font-semibold">Payment Gateway Video</p>
                </div>
              </div>

              <div className="lg:w-1/2 text-center lg:text-left">
                <h1 className="text-4xl md:text-5xl font-bold mb-6">
                  <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">Payment</span>{' '}
                  <span className="text-gray-800">Solutions</span>
                </h1>
                <p className="text-gray-600 text-lg leading-relaxed max-w-2xl">
                  Our Pay-in and Payout solutions provide businesses with a seamless, secure, and fully customizable payment infrastructure.
                  Whether you need to collect funds from customers or disburse payments to vendors, our platform offers a comprehensive suite of features designed to enhance your financial operations.
                </p>
              </div>
            </div>

            <div className="text-center mb-16 mx-auto">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold whitespace-nowrap relative z-20 inline-block">
                <div className="inline-block perspective-1000">
                  <div
                    className={`transition-all duration-1000 ease-in-out transform-gpu inline-block ${currentText === 1 ? 'rotate-y-180' : 'rotate-y-0'
                      }`}
                    style={{
                      transformStyle: 'preserve-3d',
                      transform: currentText === 1
                        ? 'rotateY(180deg) scale(1.05)'
                        : 'rotateY(0deg) scale(1)',
                    }}
                  >
                    <div
                      className="backface-hidden whitespace-nowrap inline-flex items-center justify-center w-full"
                      style={{ backfaceVisibility: 'hidden' }}
                    >
                      <span className="bg-gradient-to-r from-purple-600 via-pink-600 to-purple-700 bg-clip-text text-transparent drop-shadow-lg">
                        Payment Gateway
                      </span>
                    </div>
                    <div
                      className="absolute inset-0 backface-hidden whitespace-nowrap inline-flex items-center justify-center w-full"
                      style={{
                        backfaceVisibility: 'hidden',
                        transform: 'rotateY(180deg)',
                      }}
                    >
                      <span className="bg-gradient-to-r from-purple-600 via-pink-600 to-purple-700 bg-clip-text text-transparent drop-shadow-lg">
                        Payment Gateway{' '}
                      </span>
                      <span className="bg-gradient-to-r from-blue-600 via-cyan-500 to-teal-600 bg-clip-text text-transparent drop-shadow-lg">
                        Backed by Blockchain
                      </span>
                    </div>
                  </div>
                </div>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {paymentSolutions.map((card, index) => (
                <div
                  key={card.id}
                  onClick={() => handleCardClick(card.url)}
                  className={`relative rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 cursor-pointer bg-white h-72 hover:scale-[1.02] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                    }`}
                  style={{
                    transitionDelay: `${index * 150}ms`
                  }}
                >
                  <div className="absolute inset-0">
                    <img
                      src={card.imagePath}
                      alt={card.title}
                      className="w-full h-full object-cover transition-opacity duration-300"
                      onLoad={(e) => {
                        e.target.nextElementSibling.style.opacity = '0';
                      }}
                      onError={(e) => {
                        e.target.style.opacity = '0';
                        e.target.nextElementSibling.style.opacity = '1';
                      }}
                    />
                    <div
                      className={`absolute inset-0 w-full h-full bg-gradient-to-br ${card.color} transition-opacity duration-300`}
                      style={{ opacity: 1 }}
                    ></div>
                    <div className={`absolute inset-0 bg-gradient-to-br ${card.color} opacity-30`}></div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  </div>

                  <div className="relative z-10 h-full flex flex-col justify-between p-8">
                    <div className="flex justify-center">
                      {card.icon}
                    </div>

                    <div className="text-center space-y-4">
                      <h3 className="text-2xl font-bold text-white mb-3 drop-shadow-lg">
                        {card.title}
                      </h3>

                      <div className="bg-black/30 backdrop-blur-sm rounded-xl p-4 border border-white/25">
                        <p className="text-white font-medium text-sm leading-relaxed drop-shadow-md">
                          {card.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section> */}





        {/* Our Products Section */}
        <section className="py-12 px-4 bg-gradient-to-r from-cyan-100 via-blue-50 to-purple-50 relative overflow-hidden">
          {/* Animated Background Elements */}
          <div className="absolute inset-0">
            <div className="absolute top-10 left-10 w-2 h-2 bg-cyan-300 rounded-full animate-pulse"></div>
            <div className="absolute top-20 right-20 w-3 h-3 bg-blue-300 rounded-full animate-bounce"></div>
            <div className="absolute bottom-16 left-1/4 w-2 h-2 bg-purple-300 rounded-full animate-pulse"></div>
            <div className="absolute bottom-10 right-1/3 w-3 h-3 bg-cyan-300 rounded-full animate-bounce"></div>
          </div>

          <div className="max-w-6xl mx-auto relative">
            {/* Section Header - Compact */}
            <div className="text-center mb-10">
              <div className="inline-block relative">
                <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-cyan-600 via-blue-600 to-purple-600 bg-clip-text text-transparent mb-2">
                  Our Solutions
                </h2>
                <div className="absolute -bottom-1 left-0 right-0 h-0.5 bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 rounded-full"></div>
              </div>
              <p className="text-gray-600 text-lg mt-4 max-w-2xl mx-auto leading-relaxed">
                Comprehensive NETC solutions and merchant management tools
              </p>
            </div>

            {/* Products Grid - Compact Cards */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
              {ourProducts.map((product, index) => (
                <div
                  key={product.id}
                  onClick={() => handleCardClick(product.url)}
                  className={`group relative cursor-pointer transform transition-all duration-500 hover:scale-[1.02] ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                    }`}
                  style={{
                    transitionDelay: `${(index + 3) * 150}ms`,
                  }}
                >
                  {/* Card Container - Same size as payment cards */}
                  <div className="relative h-72 rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 bg-white">
                    {/* Light Background Gradient */}
                    <div className={`absolute inset-0 bg-gradient-to-br ${product.color} opacity-80 group-hover:opacity-90 transition-opacity duration-500`}></div>

                    {/* Light Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-black/10 to-transparent"></div>

                    {/* Floating Animation Background */}
                    <div className="absolute inset-0 opacity-10 group-hover:opacity-20 transition-opacity duration-500">
                      <div className="absolute top-4 left-4 w-8 h-8 bg-white rounded-full animate-pulse"></div>
                      <div className="absolute top-8 right-6 w-6 h-6 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.5s' }}></div>
                      <div className="absolute bottom-8 left-8 w-4 h-4 bg-white rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
                    </div>

                    {/* Content */}
                    <div className="relative z-10 h-full flex flex-col justify-between p-6">
                      {/* Icon */}
                      <div className="flex justify-center">
                        <div className="p-3 rounded-2xl bg-white/25 backdrop-blur-sm border border-white/30 group-hover:bg-white/35 group-hover:scale-110 transition-all duration-500">
                          <div className="text-white group-hover:scale-105 transition-transform duration-500">
                            {product.icon}
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="text-center space-y-3">
                        <h3 className="text-xl font-bold text-white mb-2 drop-shadow-lg group-hover:text-2xl transition-all duration-500">
                          {product.title}
                        </h3>

                        <div className="bg-white/20 backdrop-blur-sm rounded-xl p-3 border border-white/25 group-hover:bg-white/30 transition-all duration-500">
                          <p className="text-white font-medium text-sm leading-relaxed drop-shadow-md">
                            {product.description}
                          </p>
                        </div>
                      </div>

                      {/* Hover Arrow */}
                      <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-x-1 group-hover:translate-x-0">
                        <div className="w-6 h-6 rounded-full bg-white/25 backdrop-blur-sm border border-white/30 flex items-center justify-center">
                          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* Bottom Glow Effect */}
                    <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>










      </div>


      {/* Video Technology Solutions - Dark */}
      {/* <div className="py-20 px-4 bg-gradient-to-br from-gray-900 via-purple-900/30 to-indigo-900/30">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-black/20 backdrop-blur-sm border border-white/10 rounded-xl p-8">
              <h2 className="text-4xl font-bold text-white mb-6 drop-shadow-lg">
                <span className="text-purple-300">+</span> Video Technology Solutions
              </h2>
              <p className="text-xl text-gray-100 mb-8 font-medium drop-shadow-md">
                Comprehensive video communication solutions for seamless business operations with Secure and compliant digital identity verification:
              </p>
              <div className="space-y-4">
                {[
                  "HD Video Conferencing",
                  "Recording & Playback",
                  "Enterprise Security",
                  "API Integration",
                  "Real-time Document Verification",
                  "Call details Reporting",
                  "Mobile & Web Compatible",
                  "End-to-end Encryption",
                ].map((feature, index) => (
                  <div key={index} className="flex items-center bg-white/5 rounded-lg p-3 border border-white/10">
                    <div className="w-3 h-3 bg-purple-400 rounded-full mr-4 shadow-lg"></div>
                    <span className="text-lg text-white font-medium drop-shadow-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="relative">
                <div className="w-full h-80 bg-gradient-to-br from-purple-600 to-indigo-600 rounded-lg flex items-center justify-center">
                  <video
                    className="w-full h-auto rounded-lg object-cover"
                    src="./videoconf.mp4"
                    autoPlay
                    muted
                    playsInline
                    style={{ pointerEvents: "none" }} // prevents right-click controls on some browsers
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div> */}






      {/* <section className="py-12 px-4 bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-16 w-2 h-2 bg-cyan-400 rounded-full animate-pulse shadow-lg shadow-cyan-400/50" style={{ animationDelay: '0s' }}></div>
          <div className="absolute top-32 right-20 w-3 h-3 bg-emerald-400 rounded-full animate-bounce shadow-lg shadow-emerald-400/50" style={{ animationDelay: '0.7s' }}></div>
          <div className="absolute bottom-28 left-1/4 w-2 h-2 bg-blue-400 rounded-full animate-pulse shadow-lg shadow-blue-400/50" style={{ animationDelay: '1.4s' }}></div>
          <div className="absolute bottom-20 right-1/3 w-3 h-3 bg-cyan-400 rounded-full animate-bounce shadow-lg shadow-cyan-400/50" style={{ animationDelay: '2.1s' }}></div>


        </div>

        <div className="max-w-6xl mx-auto relative">
          <div className="flex flex-col lg:flex-row items-center gap-8">

            <div
              className={`lg:w-1/2 text-center lg:text-left transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
                }`}
              style={{ transitionDelay: '200ms' }}
            >
              <div className="flex items-center justify-center lg:justify-start gap-4 mb-6">
                <div className="relative">
                  <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg transform hover:scale-110 transition-all duration-500">
                    <svg className="w-7 h-7 text-white animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ animationDelay: '0.3s' }}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                    </svg>
                  </div>
                  <div className="absolute inset-0 rounded-xl border-2 border-cyan-400 animate-spin opacity-40" style={{ animationDuration: '4s' }}></div>
                  <div className="absolute inset-0 rounded-xl border border-emerald-400 animate-ping opacity-30"></div>
                  <div className="absolute inset-0 rounded-xl border border-blue-400 animate-pulse opacity-20"></div>
                </div>

                <h2
                  className={`text-3xl md:text-4xl font-bold transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
                    }`}
                  style={{ transitionDelay: '600ms' }}
                >
                  <span className="bg-gradient-to-r from-cyan-600 via-emerald-600 to-blue-600 bg-clip-text text-transparent">
                    Recon
                  </span>
                  <span className="text-gray-800 ml-2">is</span>
                  <span className="bg-gradient-to-r from-emerald-600 via-cyan-600 to-blue-600 bg-clip-text text-transparent ml-2">
                    AI Enabled
                  </span>
                </h2>
              </div>

              <p
                className={`text-gray-600 text-lg leading-relaxed mb-6 transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
                  }`}
                style={{ transitionDelay: '800ms' }}
              >
                Experience next-generation reconciliation powered by artificial intelligence.
                Our AI algorithms automatically detect discrepancies, predict patterns, and streamline your financial operations.
              </p>

              <div
                className={`grid grid-cols-2 gap-4 mb-6 transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                style={{ transitionDelay: '1000ms' }}
              >
                {[
                  { icon: "🤖", title: "Smart Matching", glow: "shadow-cyan-400/30" },
                  { icon: "🧠", title: "Pattern Learning", glow: "shadow-emerald-400/30" },
                  { icon: "⚡", title: "Real-time Analysis", glow: "shadow-blue-400/30" },
                  { icon: "🎯", title: "Anomaly Detection", glow: "shadow-cyan-400/30" }
                ].map((feature, index) => (
                  <div
                    key={index}
                    className={`group bg-white/70 backdrop-blur-sm rounded-lg p-3 border border-gray-200 hover:bg-white/90 hover:scale-105 transition-all duration-300 hover:shadow-lg ${feature.glow} text-center`}
                    style={{ transitionDelay: `${1200 + index * 100}ms` }}
                  >
                    <div className="text-xl mb-1 group-hover:scale-110 transition-transform duration-300">
                      {feature.icon}
                    </div>
                    <h4 className="font-semibold text-gray-800 text-sm">{feature.title}</h4>
                  </div>
                ))}
              </div>

              <div
                className={`transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
                  }`}
                style={{ transitionDelay: '1400ms' }}
              >

              </div>
            </div>

            <div
              className={`lg:w-1/2 flex justify-center transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
                }`}
              style={{ transitionDelay: '400ms' }}
            >
              <div className="relative group">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group-hover:shadow-cyan-500/25 transition-all duration-500">
                  <div className="absolute -inset-1 bg-gradient-to-r from-cyan-600 via-emerald-600 to-blue-600 rounded-2xl opacity-0 group-hover:opacity-30 transition-opacity duration-500 animate-pulse"></div>

                  <video
                    className="w-80 h-52 object-cover rounded-2xl"
                    src="./reconAI.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    controls={false}
                    onError={(e) => {
                      // Fallback if video doesn't load
                      e.target.style.display = 'none';
                      e.target.nextElementSibling.style.display = 'flex';
                    }}
                  />

                  <div className="w-80 h-52 bg-gradient-to-br from-cyan-600 via-emerald-600 to-blue-600 rounded-2xl items-center justify-center text-white text-center p-6 hidden relative overflow-hidden">
                    <div className="absolute inset-0 opacity-20">
                      <div className="grid grid-cols-6 h-full">
                        {Array.from({ length: 24 }).map((_, i) => (
                          <div key={i} className="border border-white/20 animate-pulse" style={{ animationDelay: `${i * 0.1}s` }}></div>
                        ))}
                      </div>
                    </div>
                    <div className="relative z-10">
                      <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                        </svg>
                      </div>
                      <div className="text-lg font-semibold mb-2">AI Recon Demo</div>
                      <div className="text-sm opacity-90">Intelligent Processing</div>
                    </div>
                  </div>
                </div>

                <div className="absolute -top-3 -left-3 w-6 h-6 bg-cyan-300 rounded-full animate-bounce opacity-70 shadow-lg shadow-cyan-300/50" style={{ animationDelay: '0s' }}></div>
                <div className="absolute -top-2 -right-4 w-4 h-4 bg-emerald-300 rounded-full animate-pulse opacity-70 shadow-lg shadow-emerald-300/50" style={{ animationDelay: '0.5s' }}></div>
                <div className="absolute -bottom-3 -left-4 w-5 h-5 bg-blue-300 rounded-full animate-bounce opacity-70 shadow-lg shadow-blue-300/50" style={{ animationDelay: '1s' }}></div>
                <div className="absolute -bottom-2 -right-3 w-6 h-6 bg-cyan-300 rounded-full animate-pulse opacity-70 shadow-lg shadow-cyan-300/50" style={{ animationDelay: '1.5s' }}></div>
              </div>
            </div>

          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-400 to-transparent opacity-50"></div>
      </section> */}


      {/* Meeting Room Management Section */}
      {/* <section className="py-12 px-4 bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-16 left-20 w-3 h-3 bg-indigo-300 rounded-full animate-pulse" style={{ animationDelay: '0s' }}></div>
          <div className="absolute top-32 right-16 w-2 h-2 bg-purple-300 rounded-full animate-bounce" style={{ animationDelay: '0.5s' }}></div>
          <div className="absolute bottom-24 left-1/3 w-4 h-4 bg-pink-300 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-16 right-1/4 w-2 h-2 bg-indigo-300 rounded-full animate-bounce" style={{ animationDelay: '1.5s' }}></div>
        </div>

        <div className="max-w-6xl mx-auto relative">
          <div className="flex flex-col lg:flex-row items-center gap-8">

            <div
              className={`lg:w-1/2 text-center lg:text-left transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
                }`}
              style={{ transitionDelay: '200ms' }}
            >
              <div className="flex items-center justify-center lg:justify-start gap-4 mb-6">
                <div className="relative">
                  <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg transform hover:scale-110 transition-all duration-500 animate-pulse">
                    <svg className="w-6 h-6 text-white animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ animationDelay: '0.5s' }}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m0 0h2M7 3v18M15 8h.01M15 12h.01" />
                    </svg>
                  </div>
                  <div className="absolute inset-0 rounded-xl border-2 border-indigo-300 animate-spin opacity-30" style={{ animationDuration: '3s' }}></div>
                  <div className="absolute inset-0 rounded-xl border border-purple-300 animate-ping opacity-20"></div>
                </div>

                <h2
                  className={`text-3xl md:text-4xl font-bold transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
                    }`}
                  style={{ transitionDelay: '400ms' }}
                >
                  <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
                    Meeting Room Management
                  </span>
                </h2>
              </div>

              <p
                className={`text-gray-600 text-lg leading-relaxed mb-6 transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
                  }`}
                style={{ transitionDelay: '600ms' }}
              >
                Streamline your workspace with our intelligent meeting room booking system.
                Real-time availability, automated scheduling, and seamless integration.
              </p>

              <div
                className={`grid grid-cols-2 md:grid-cols-4 gap-3 mb-6 transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                style={{ transitionDelay: '800ms' }}
              >
                {[
                  { icon: "📅", title: "Smart Booking" },
                  { icon: "📊", title: "Analytics" },
                  { icon: "🔧", title: "Integration" },
                  { icon: "📱", title: "Mobile App" }
                ].map((feature, index) => (
                  <div
                    key={index}
                    className="group bg-white/60 backdrop-blur-sm rounded-lg p-3 border border-white/50 hover:bg-white/80 hover:scale-105 transition-all duration-300 hover:shadow-lg text-center"
                    style={{ transitionDelay: `${1000 + index * 100}ms` }}
                  >
                    <div className="text-xl mb-1 group-hover:scale-110 transition-transform duration-300">
                      {feature.icon}
                    </div>
                    <h4 className="font-semibold text-gray-800 text-sm">{feature.title}</h4>
                  </div>
                ))}
              </div>

              <div
                className={`transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
                  }`}
                style={{ transitionDelay: '1200ms' }}
              >

              </div>
            </div>

            <div
              className={`lg:w-1/2 flex justify-center transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
                }`}
              style={{ transitionDelay: '400ms' }}
            >
              <div className="relative group">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group-hover:shadow-3xl transition-all duration-500">
                  <div className="absolute -inset-1 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-2xl opacity-0 group-hover:opacity-20 transition-opacity duration-500"></div>

                  <video
                    className="w-80 h-52 object-cover rounded-2xl"
                    src="./mrm.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    controls={false}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextElementSibling.style.display = 'flex';
                    }}
                  />

                  <div className="w-80 h-52 bg-gradient-to-br from-indigo-500 via-purple-600 to-pink-600 rounded-2xl items-center justify-center text-white text-center p-6 hidden">
                    <div className="text-lg font-semibold mb-2">Meeting Room Demo</div>
                    <div className="text-sm opacity-90">Interactive Booking Experience</div>
                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mt-4 mx-auto">
                      <svg className="w-5 h-5 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="absolute -top-3 -left-3 w-6 h-6 bg-indigo-200 rounded-full animate-bounce opacity-60" style={{ animationDelay: '0s' }}></div>
                <div className="absolute -top-2 -right-4 w-4 h-4 bg-purple-200 rounded-full animate-pulse opacity-60" style={{ animationDelay: '0.5s' }}></div>
                <div className="absolute -bottom-3 -left-4 w-5 h-5 bg-pink-200 rounded-full animate-bounce opacity-60" style={{ animationDelay: '1s' }}></div>
                <div className="absolute -bottom-2 -right-3 w-6 h-6 bg-indigo-200 rounded-full animate-pulse opacity-60" style={{ animationDelay: '1.5s' }}></div>
              </div>
            </div>

          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-300 to-transparent"></div>
      </section> */}



      {/* <section className="py-12 px-4 bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-20 left-16 w-2 h-2 bg-orange-400 rounded-full animate-pulse shadow-lg shadow-orange-400/50" style={{ animationDelay: '0s' }}></div>
          <div className="absolute top-32 right-20 w-3 h-3 bg-indigo-400 rounded-full animate-bounce shadow-lg shadow-indigo-400/50" style={{ animationDelay: '0.7s' }}></div>
          <div className="absolute bottom-28 left-1/4 w-2 h-2 bg-purple-400 rounded-full animate-pulse shadow-lg shadow-purple-400/50" style={{ animationDelay: '1.4s' }}></div>
          <div className="absolute bottom-20 right-1/3 w-3 h-3 bg-orange-400 rounded-full animate-bounce shadow-lg shadow-orange-400/50" style={{ animationDelay: '2.1s' }}></div>
        </div>

        <div className="max-w-6xl mx-auto relative">
          <div className="flex flex-col lg:flex-row items-center gap-8">

            <div
              className={`lg:w-1/2 text-center lg:text-left transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
                }`}
              style={{ transitionDelay: '200ms' }}
            >
              <div className="flex items-center justify-center lg:justify-start gap-4 mb-6">
                <div className="relative">
                  <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg transform hover:scale-110 transition-all duration-500">
                    <svg className="w-7 h-7 text-white animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ animationDelay: '0.3s' }}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4m-6-5h2.586a1 1 0 01.707.293L9 14.586a1 1 0 00.707.293H12a1 1 0 00.707-.293l2.707-2.707A1 1 0 0116.414 11H19" />
                    </svg>
                  </div>
                  <div className="absolute inset-0 rounded-xl border-2 border-orange-400 animate-spin opacity-40" style={{ animationDuration: '4s' }}></div>
                  <div className="absolute inset-0 rounded-xl border border-indigo-400 animate-ping opacity-30"></div>
                  <div className="absolute inset-0 rounded-xl border border-purple-400 animate-pulse opacity-20"></div>
                </div>

                <h2
                  className={`text-3xl md:text-4xl font-bold transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
                    }`}
                  style={{ transitionDelay: '600ms' }}
                >
                  <span className="bg-gradient-to-r from-orange-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">
                    UPI Switch
                  </span>
                  <span className="text-gray-800 ml-2"></span>
                  <span className="bg-gradient-to-r from-indigo-600 via-orange-600 to-purple-600 bg-clip-text text-transparent ml-2">

                  </span>
                </h2>
              </div>

              <p
                className={`text-gray-600 text-lg leading-relaxed mb-6 transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
                  }`}
                style={{ transitionDelay: '800ms' }}
              >
                Our UPI Switch solution is ready for deployment with seamless payment processing capabilities.
                Experience cost-effective implementation with transaction-based pricing and on-demand technical support.
              </p>

              <div
                className={`space-y-4 mb-6 transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                style={{ transitionDelay: '1000ms' }}
              >
                {[
                  {
                    icon: "🚀",
                    title: "Ready for Deployment",
                    description: "UPI Switch is fully prepared and ready to go live",
                    glow: "shadow-orange-400/30"
                  },
                  {
                    icon: "💰",
                    title: "Cost-Free Implementation",
                    description: "Acquirer solution with transaction-based pricing only",
                    glow: "shadow-indigo-400/30"
                  },
                  {
                    icon: "🛠️",
                    title: "On-Demand Support",
                    description: "Technical resources available whenever you need them",
                    glow: "shadow-purple-400/30"
                  }
                ].map((benefit, index) => (
                  <div
                    key={index}
                    className={`group bg-white/70 backdrop-blur-sm rounded-lg p-4 border border-gray-200 hover:bg-white/90 hover:scale-102 transition-all duration-300 hover:shadow-lg ${benefit.glow}`}
                    style={{ transitionDelay: `${1200 + index * 150}ms` }}
                  >
                    <div className="flex items-start gap-3">
                      <div className="text-2xl group-hover:scale-110 transition-transform duration-300 mt-1">
                        {benefit.icon}
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-800 text-base mb-1">{benefit.title}</h4>
                        <p className="text-sm text-gray-600">{benefit.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div
                className={`grid grid-cols-2 gap-3 mb-6 transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                style={{ transitionDelay: '1600ms' }}
              >
                {[
                  { icon: "⚡", title: "Fast Processing", glow: "shadow-orange-400/30" },
                  { icon: "🔒", title: "Secure Gateway", glow: "shadow-indigo-400/30" },
                  { icon: "📱", title: "Mobile Ready", glow: "shadow-purple-400/30" },
                  { icon: "🔄", title: "Real-time Switch", glow: "shadow-orange-400/30" }
                ].map((feature, index) => (
                  <div
                    key={index}
                    className={`group bg-white/60 backdrop-blur-sm rounded-lg p-3 border border-gray-200 hover:bg-white/80 hover:scale-105 transition-all duration-300 hover:shadow-md ${feature.glow} text-center`}
                    style={{ transitionDelay: `${1800 + index * 100}ms` }}
                  >
                    <div className="text-xl mb-1 group-hover:scale-110 transition-transform duration-300">
                      {feature.icon}
                    </div>
                    <h4 className="font-semibold text-gray-800 text-sm">{feature.title}</h4>
                  </div>
                ))}
              </div>
            </div>

            <div
              className={`lg:w-1/2 flex justify-center transform transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
                }`}
              style={{ transitionDelay: '400ms' }}
            >
              <div className="relative group">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group-hover:shadow-orange-500/25 transition-all duration-500">
                  <div className="absolute -inset-1 bg-gradient-to-r from-orange-600 via-indigo-600 to-purple-600 rounded-2xl opacity-0 group-hover:opacity-30 transition-opacity duration-500 animate-pulse"></div>

                  <video
                    className="w-80 h-52 object-cover rounded-2xl"
                    src="./upiSwitchVideo.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                    controls={false}
                    onError={(e) => {
                      // Fallback if video doesn't load
                      e.target.style.display = 'none';
                      e.target.nextElementSibling.style.display = 'flex';
                    }}
                  />

                  <div className="w-80 h-52 bg-gradient-to-br from-orange-600 via-indigo-600 to-purple-600 rounded-2xl items-center justify-center text-white text-center p-6 hidden relative overflow-hidden">
                    <div className="absolute inset-0 opacity-20">
                      <div className="grid grid-cols-8 h-full">
                        {Array.from({ length: 32 }).map((_, i) => (
                          <div
                            key={i}
                            className="border border-white/20 animate-pulse flex items-center justify-center"
                            style={{ animationDelay: `${i * 0.05}s` }}
                          >
                            {i % 4 === 0 && <div className="w-1 h-1 bg-white/30 rounded-full"></div>}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="relative z-10">
                      <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 9l4-4 4 4m0 6l-4 4-4-4m-6-5h2.586a1 1 0 01.707.293L9 14.586a1 1 0 00.707.293H12a1 1 0 00.707-.293l2.707-2.707A1 1 0 0116.414 11H19" />
                        </svg>
                      </div>
                      <div className="text-xl font-bold mb-2">UPI Switch Demo</div>
                      <div className="text-sm opacity-90 mb-1">Ready for Deployment</div>
                      <div className="text-xs opacity-75">Transaction-Based Pricing</div>
                    </div>

                    <div className="absolute top-4 left-4 w-2 h-2 bg-white/60 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
                    <div className="absolute top-8 right-6 w-1 h-1 bg-white/40 rounded-full animate-ping" style={{ animationDelay: '0.3s' }}></div>
                    <div className="absolute bottom-6 left-8 w-2 h-2 bg-white/50 rounded-full animate-pulse" style={{ animationDelay: '0.6s' }}></div>
                    <div className="absolute bottom-4 right-4 w-1 h-1 bg-white/60 rounded-full animate-bounce" style={{ animationDelay: '0.9s' }}></div>
                  </div>
                </div>

                <div className="absolute -top-3 -left-3 w-6 h-6 bg-orange-300 rounded-full animate-bounce opacity-70 shadow-lg shadow-orange-300/50" style={{ animationDelay: '0s' }}></div>
                <div className="absolute -top-2 -right-4 w-4 h-4 bg-indigo-300 rounded-full animate-pulse opacity-70 shadow-lg shadow-indigo-300/50" style={{ animationDelay: '0.5s' }}></div>
                <div className="absolute -bottom-3 -left-4 w-5 h-5 bg-purple-300 rounded-full animate-bounce opacity-70 shadow-lg shadow-purple-300/50" style={{ animationDelay: '1s' }}></div>
                <div className="absolute -bottom-2 -right-3 w-6 h-6 bg-orange-300 rounded-full animate-pulse opacity-70 shadow-lg shadow-orange-300/50" style={{ animationDelay: '1.5s' }}></div>
              </div>
            </div>

          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-orange-400 to-transparent opacity-50"></div>
      </section> */}


      {/* 
      <div className="py-20 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 animate-fade-in-up">
            <span className="inline-block animate-pulse bg-gradient-to-r from-blue-600 via-purple-600 to-cyan-600 bg-clip-text text-transparent">
              Smart Solutions
            </span>{" "}
            <span className="inline-block animate-bounce-slow">
              That Drive Results
            </span>
          </h2>

          <style jsx>{`
          @keyframes fade-in-up {
            0% {
              opacity: 0;
              transform: translateY(20px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes bounce-slow {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-3px);
            }
            60% {
              transform: translateY(-1px);
            }
          }
          
          .animate-fade-in-up {
            animation: fade-in-up 1s ease-out;
          }
          
          .animate-bounce-slow {
            animation: bounce-slow 2s infinite;
            animation-delay: 0.5s;
          }
        `}</style>

          <div className="grid md:grid-cols-5 gap-8 mt-16">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div
                  className={`w-16 h-16 bg-${feature.color}-100 rounded-full flex items-center justify-center mx-auto mb-4`}
                >
                  <div className={`text-${feature.color}-600`}>
                    {feature.icon}
                  </div>
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-600">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div> */}




      {/* Why Choose Us - Light */}
      {/* <div className="py-20 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
            The Advantage We Deliver
          </h2>


          <div className="grid md:grid-cols-5 gap-8 mt-16">
            {
              [
                {
                  icon: <Shield className="w-8 h-8" />,
                  title: "Secure",
                  desc: "Enterprise-grade security for all your business data",
                  color: "blue",
                },
                {
                  icon: <CheckCircle className="w-8 h-8" />,
                  title: "Compliance",
                  desc: "Compliance support across all solutions",
                  color: "green",
                },
                {
                  icon: <TrendingUp className="w-8 h-8" />,
                  title: "Expandable",
                  desc: "Solutions that grow with your business needs",
                  color: "purple",
                },
                {
                  icon: <Headphones className="w-8 h-8" />,
                  title: "Follow-up Model",
                  desc: "Systematic customer engagement and progress tracking",
                  color: "orange",
                },
                {
                  icon: <Zap className="w-8 h-8" />,
                  title: "API-Driven",
                  desc: "Seamless integration with existing systems",
                  color: "cyan",
                },
              ]
                .map((feature, index) => (
                  <div key={index} className="text-center">
                    <div
                      className={`w-16 h-16 bg-${feature.color}-100 rounded-full flex items-center justify-center mx-auto mb-4`}
                    >
                      <div className={`text-${feature.color}-600`}>
                        {feature.icon}
                      </div>
                    </div>
                    <h3 className="font-semibold text-gray-900 mb-2">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.desc}</p>
                  </div>
                ))}
          </div>
        </div>
      </div> */}

      <section id="features" className="relative z-10 px-6 py-20 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">
              <span className="bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
                Our Differentiators
              </span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Built for modern businesses that demand speed, security, and seamless integration
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`group p-6 bg-white shadow-lg hover:shadow-xl transition-all duration-500 border border-gray-200 rounded-2xl hover:border-blue-300/50 hover:-translate-y-2 ${currentFeature === index ? '' : ''}`}
              >
                <div className="w-12 h-12 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <div className="text-white">
                    {feature.icon}
                  </div>
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-sm">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>




      {/* CTA Section */}
      <section className="py-8 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-700 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-40 right-20 w-24 h-24 bg-white/5 rounded-lg animate-bounce transform rotate-45" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
          <div className="absolute bottom-40 right-10 w-20 h-20 bg-white/5 rounded-lg animate-bounce transform -rotate-12" style={{ animationDelay: '0.5s' }}></div>

          <div className="absolute top-1/4 left-1/4 animate-float">
            <Zap className="w-8 h-8 text-white/20" />
          </div>
          <div className="absolute top-1/3 right-1/3 animate-float" style={{ animationDelay: '1.5s' }}>
            <Shield className="w-6 h-6 text-white/20" />
          </div>
          <div className="absolute bottom-1/3 left-1/3 animate-float" style={{ animationDelay: '3s' }}>
            <TrendingUp className="w-7 h-7 text-white/20" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          {/* Main Content */}


          <div className="space-y-4 animate-fadeInUp">
            <h2 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-white leading-tight animate-slideInLeft">
              Ready to Transform Your Business?
            </h2>
            <p className="text-white">Get started with our comprehensive suite of business solutions today
            </p>
          </div>

          {/* CTA Button - Smaller and More Compact */}
          <div className="mt-6 animate-fadeInUp" style={{ animationDelay: '1.2s' }}>
            <button
              className="group relative inline-flex items-center gap-3 bg-gradient-to-r from-white to-blue-50 text-blue-700 px-8 py-3 rounded-xl font-semibold text-lg hover:from-yellow-300 hover:to-orange-300 hover:text-gray-900 transform hover:scale-105 transition-all duration-500 shadow-xl hover:shadow-yellow-300/50"
              onClick={() => {
                window.location.href = '/contact';
              }}
            >
              <Play className="w-5 h-5 group-hover:animate-bounce" />
              <span>Get In Touch</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />

              {/* Button Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </button>
          </div>
        </div>

        <style jsx>{`
                  @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    33% { transform: translateY(-10px) rotate(5deg); }
                    66% { transform: translateY(5px) rotate(-5deg); }
                  }
                  
                  @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(30px); }
                    to { opacity: 1; transform: translateY(0); }
                  }
                  
                  @keyframes slideInLeft {
                    from { opacity: 0; transform: translateX(-50px); }
                    to { opacity: 1; transform: translateX(0); }
                  }
                  
                  @keyframes slideInRight {
                    from { opacity: 0; transform: translateX(50px); }
                    to { opacity: 1; transform: translateX(0); }
                  }
                  
                  @keyframes slideInUp {
                    from { opacity: 0; transform: translateY(40px); }
                    to { opacity: 1; transform: translateY(0); }
                  }
                  
                  .animate-float {
                    animation: float 4s ease-in-out infinite;
                  }
                  
                  .animate-fadeInUp {
                    animation: fadeInUp 0.8s ease-out forwards;
                    opacity: 0;
                  }
                  
                  .animate-slideInLeft {
                    animation: slideInLeft 0.8s ease-out forwards;
                    opacity: 0;
                  }
                  
                  .animate-slideInRight {
                    animation: slideInRight 0.8s ease-out forwards;
                    opacity: 0;
                  }
                  
                  .animate-slideInUp {
                    animation: slideInUp 0.8s ease-out forwards;
                    opacity: 0;
                  }
                `}</style>
      </section>
      <Footer />
    </div>
  );
};

export default BusinessLanding;
